import { AppError } from './app-error';

export class DomainError extends AppError {
  readonly code: string;
  readonly details?: string[];

  constructor(code: string, message: string, details?: string[]) {
    super(message);
    this.code = code;
    this.details = details;
  }

  getFullMessage(): string {
    if (!this.details || this.details.length === 0) {
      return this.message;
    }
    return `${this.message}: ${this.details.join(', ')}`;
  }

  hasDetails(): boolean {
    return Boolean(this.details && this.details.length > 0);
  }

  getDetails(): string[] {
    return this.details || [];
  }
}
